import { ApiService } from '../services/api_service';
import * as config from '../wips.config.js';
import { DataService } from '../services/data_service';
import { IDs } from '../helpers/IDs';
import { KontaktFaq } from './KontaktFaq';
import { lazyInject } from '../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { WFormData } from '../core/forms/WFormData';
import { WFormsTableWrapper } from '../core/table/WFormsTableWrapper';

export interface KontaktProps {
    onClose?(): void;
}

export interface KontaktState {
    bereich: string;
    faq: any[];
    showFaq: boolean;
    thema: number;
}

export class Kontakt extends React.Component<KontaktProps, KontaktState> {

    constructor(props: any) {
        super(props);
        this.state = {
            bereich: null,
            faq: [],
            showFaq: false,
            thema: null
        };
        this.filterBundle = this.filterBundle.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;

    private formConfig: any = {};
    private formPreset: any = {};

    componentDidMount(): void {
        const bereich: string = this.apiService.getBereichKey() || null;

        if ((config || {}).preset_bereich) {
            this.formPreset.bereich_key = config.preset_bereich;
            this.formConfig.bereich_key = { hidden: true };
        } else if (bereich && bereich !== 'all') {
            this.formPreset.bereich_key = bereich;
            this.formConfig.bereich_key = { hidden: true };
        }
    }

    filterBundle(bundle: any) {
        bundle.bereich_key = bundle.bereich_key.filter((item: any) => item.intern_key !== 'kommunalverwaltung');
    }

    onFormChange(WFormData: WFormData): void {
        WFormData.setValue('timestamp', Moment().unix());
        this.setState({ bereich: WFormData.getValue('bereich_key'), thema: WFormData.getValue('thema') });
    }

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                key='kontakt'
                entity={IDs.ENT_KONTAKT}
                module={IDs.MOD_ETOOL_ADMIN}
                formTitel='Nachricht versenden'
                formLayout='flowV2'
                customClass='Custom-ETA'
                customCssStyle={{
                    formField: { text: { styleTextarea: { height: 200 } } }
                }}
                directEditFormularOf={{ tid: 0 }}
                formPreset={this.formPreset}
                customFormConfig={this.formConfig}
                preFilterServer={{ tid: 0 }}
                extraFormElementAfter={{
                    text: this.renderFaq()
                }}
                formSimpleValidationMsg={['bereich_key', 'thema', 'titel']}
                validRestriction='stop'
                bundleFilterFunc={this.filterBundle}
                onFormChange={this.onFormChange}
                onSaveDone={() => alert('Die Nachricht wurde erfolgreich gespeichert.')}
                onAfterAction={(action: string) => {
                    if (action === 'closeForm') {
                        this.props.onClose();
                    }
                }}
            />
        );
    }

    renderFaq(): JSX.Element {
        return (
            <div
                style={{
                    lineHeight: 1, paddingRight: 10, marginBottom: 30, display: 'flex', flexDirection: 'column', alignItems: 'flex-start'
                }}
            >
                <div
                    style={{ width: '100%', paddingBottom: 4, cursor: 'pointer', userSelect: 'none' }}
                    onClick={() => this.setState({ showFaq: !this.state.showFaq })}
                >
                    FAQ ({this.state.faq.length}){this.state.showFaq ? <>&#9660;</> : <>&#9650;</>}
                </div>
                <KontaktFaq
                    bereich={this.state.bereich}
                    onDataLoaded={(data: any[]) => this.setState({ faq: data || [] })}
                    style={{ display: this.state.showFaq ? 'block' : 'none' }}
                    thema={this.state.thema}
                />
            </div>
        );
    }
}
